import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Route, Switch } from 'react-router-dom';
import { TextEditor } from 'app/main/Tools/Editor.jsx';
export function Tools() {
    return (_jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/tools", component: () => (_jsxs("div", { className: "padding20 overflowXAuto overflowYAuto", children: [_jsxs("p", { className: "margin10", children: [_jsx("h3", { children: _jsx(Link, { to: "/tools/editor", children: "Editor" }) }), _jsxs("div", { className: "padding20", children: [_jsx("div", { children: "You can access the CKEditor module through the window.CKEditor shortcut" }), _jsxs("div", { children: ["The available API for the module is here:", ' ', _jsx("a", { href: "https://ckeditor.com/docs/ckeditor5/latest/api/index.html", children: "CKEditor API" })] }), _jsxs("div", { className: "paddingTop20 paddingBottom20", children: [_jsx("div", { className: "bold", children: "Features" }), _jsxs("div", { className: "padding20", children: ["Add ", _jsxs("code", { children: ["?toolbar=", `<base64Encoded Array>`] }), " to determine toolbar elements.", _jsx("br", {}), "Default value is:", _jsx("pre", { children: `[
  'heading',
  '|',
  'fontSize',
  'fontColor',
  'fontBackgroundColor',
  '|',
  'outdent',
  'indent',
  '|',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'bulletedList',
  'numberedList',
  'alignment',
  'blockQuote',
  'link',
  'horizontalLine',
  '|',
  'imageUpload',
  'insertFile',
  'insertTable',
  '|',
  'codeBlock',
  'code',
  '|',
  'undo',
  'redo',
]` })] })] })] })] }), _jsxs("p", { className: "margin10", children: [_jsx("h3", { children: _jsx(Link, { to: "/tools/editor-raw-css", children: "Editor css" }) }), _jsxs("div", { className: "padding20", children: ["Raw editor css selectable with id: ", _jsx("code", { children: "#editor-raw-css" })] })] }), _jsxs("p", { className: "margin10", children: [_jsx("h3", { children: _jsx(Link, { to: "/tools/reader-raw-css", children: "Reader css" }) }), _jsxs("div", { className: "padding20", children: ["Raw reader css selectable with id: ", _jsx("code", { children: "#reader-raw-css" })] })] })] })) }), _jsx(Route, { exact: true, path: "/tools/editor", component: TextEditor })] }));
}
